export const sponsorsNumberOptions = [
  { value: 49, label: '10 a 49' },
  { value: 99, label: '50 a 99' },
  { value: 249, label: '100 a 249' },
  { value: 251, label: '250 ou mais' },
];
